import React, { createContext } from 'react'

// WizzardHeaderContext context
interface WizzardHeaderContextType {
  isScrolled: boolean
  setIsScrolled: React.Dispatch<React.SetStateAction<boolean>>
  // Header height
  headerHeight?: number
  setHeaderHeight?: React.Dispatch<React.SetStateAction<number>>
}

const defaultState = {
  isScrolled: false,
}

const WizzardHeaderContext = createContext<WizzardHeaderContextType>(
  defaultState as WizzardHeaderContextType,
)

// WizzardHeaderProvider component
export interface WizzardHeaderProviderProps extends React.PropsWithChildren {
  isScrolled?: boolean
}

export const WizzardHeaderProvider = (props: WizzardHeaderProviderProps) => {
  const { children } = props
  const [isScrolled, setIsScrolled] = React.useState<boolean>(false)
  const [headerHeight, setHeaderHeight] = React.useState<number>(0)

  return (
    <WizzardHeaderContext.Provider
      value={{ isScrolled, setIsScrolled, headerHeight, setHeaderHeight }}
    >
      {children}
    </WizzardHeaderContext.Provider>
  )
}

// useWizzardHeader hook
export interface useWizzardHeaderReturn {
  // is scrolled
  isScrolled: boolean
  setIsScrolled: React.Dispatch<React.SetStateAction<boolean>>
  // Header height
  headerHeight?: number
  setHeaderHeight?: React.Dispatch<React.SetStateAction<number>>
}

export const useWizzardHeader = (): useWizzardHeaderReturn => {
  const context = React.useContext(WizzardHeaderContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error(
      'useWizzardHeader must be used within a WizzardHeaderProvider',
    )
  }

  return {
    // is scrolled
    isScrolled: context.isScrolled,
    setIsScrolled: context.setIsScrolled,
    // Header height
    headerHeight: context.headerHeight,
    setHeaderHeight: context.setHeaderHeight,
  }
}
